<template>
  <v-container :style="{height: '100%'}">
    <v-row align="center" justify="center">
        <logo></logo>
    </v-row>
    <v-row justify="space-around">
      <div class="pa-5">
        <v-row class="ma-2" align="center" justify="center">
          <check width="216" height="216" ></check>
        </v-row>
      </div>
    </v-row>

    
    <v-row justify="space-around" :style="{height: '20vh'}">
      <h1 >¡Listo! ¡Muchas Gracias!</h1>
    </v-row>
      <v-row justify="center" align="center" >
        <portal-practicas-card />
      </v-row>
  </v-container>
</template>

<script>
import logo from "@/components/icons/logoDI";
import Check from '@/components/icons/check.vue';
import PortalPracticasCard from '@/components/content/PortalPracticasCard.vue';

export default {
  components: {
    logo, Check, PortalPracticasCard
  },
};
</script>

<style>
</style>